import { gql } from "@apollo/client";

export const GET_FRECUENCIAS_PROFESIONALES = gql`
query GetFrecuenciasProfesionales {
    frecuenciasProfesionales {
            idFrecuenciaProfesional
            descripccion
            descripcionpp
            frecuencia
            guardia
      }
}`;